import { render, staticRenderFns } from "./ThreadDiscussionMessage.vue?vue&type=template&id=9ed139b2"
import script from "./ThreadDiscussionMessage.vue?vue&type=script&lang=js"
export * from "./ThreadDiscussionMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports